import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import LogoStrip from './components/LogoStrip';
import Reviews from './components/Reviews';
import Products from './components/Products';
import InstantSection from './components/InstantSection';
import SwitchSection from './components/SwitchSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <LogoStrip />
      <Reviews />
      <Products />
      <InstantSection />
      <SwitchSection />
      <Footer />
    </div>
  );
}

export default App;